export default __webpack_public_path__ + "static/media/dryness.ffe74381.svg";